import React, { useState } from 'react';
import './Header.css';
import logo from '../assets/images/logo.png';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="header">
      <img alt="Logo" src={logo} className="logo" id="header-logo" />
      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
      ☰
      </div>
      <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
        <a href="https://prairiedonair.com/" className="header-link">Home</a>
        <a href="https://prairiedonair.com/menu/" className="header-link">Menu</a>
        <a href="https://prairiedonair.com/franchise/" className="header-link">Franchise</a>
        <a href="https://prairiedonair.com/contact/" className="header-link">Contact</a>
      </nav>
    </header>
  );
}

export default Header;